import React from 'react';
import { Flex, Box, Center } from '@chakra-ui/react';

interface StepperProps {
  currentStep: number;
  steps: { number: number; h: string }[];
}

export const Stepper = ({ currentStep = 1, steps }: StepperProps) => {
  return (
    <Box
      aria-hidden="true"
      mt="28px"
      mr="24px"
      display={{ md: 'block', base: 'none' }}
    >
      {steps.map(({ number, h }) => (
        <Flex key={number} direction="column" alignItems="center">
          <Center
            transition="all 2s"
            borderRadius="18px"
            w={currentStep >= number ? '34px' : '24px'}
            h={currentStep >= number ? '34px' : '24px'}
            bg={currentStep >= number ? 'ocean.100' : 'grey.500'}
          >
            {currentStep >= number && number}
          </Center>
          {number !== 3 && (
            <Box bg="grey.600" w="2px" h={h}>
              <Box
                transition="all 1s"
                bg={currentStep >= number ? 'ocean.100' : 'grey.500'}
                h={currentStep > number ? '100%' : ' 0%'}
              />
            </Box>
          )}
        </Flex>
      ))}
    </Box>
  );
};
